var $ = require('jquery');
var holidayCalendar = require('./holidayCalendar');

module.exports = function () {
    if (typeof WdatePicker === 'undefined') {
        throw new Error('trfWdatePicker method requires WdatePicker')
    }

    var setHoliday = holidayCalendar();
    /**
     * 可以显示节假日 日历
     * @param options
     * container  当一个界面上存在2种日历显示，一种点击弹出显示，一种平面显示【平面显示日历会放在一个div里】，平面显示的日历请传container 包含的div
     * 如：holidayWdatePicker({eCont:'calendar',skin:'twoer',doubleCalendar:true,container:'#calendar'})
     */
    var holidayWdatePicker = function(options) {
        options = $.extend({},{container:'body>div[lang="zh-cn"]'},options);
        var container = options.container
        var holidayOption={
            Mchanged: function () {
                setHoliday(container);
            },
            ychanged: function () {
                setHoliday(container);
            },
            onpicked: function () {
                setHoliday(container);
            }
        };
        if (options.Mchanged) {
            holidayOption.Mchanged = function () {
                options.Mchanged();
                setHoliday(container);
            };
        }
        if (options.ychanged) {
            holidayOption.ychanged = function () {
                options.ychanged();
                setHoliday(container);
            };
        }
        if (options.onpicked) {
            holidayOption.onpicked = function () {
                options.onpicked();
                setHoliday(container);
            };
        }
        var obj = $.extend({},(options || {}),holidayOption)
        WdatePicker.call(null,obj);
        setHoliday(container,options.isShowHoliday);
    }

    return holidayWdatePicker;
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/wdatePicker/index.js
// module id = 202
// module chunks = 0